<template>
  <div :class="type" class="alert-container d-flex align-items-start ">
    <img class="mr-10" :src="icon" />
    <p class="m-0 text-alert">{{ text }}</p>
  </div>
</template>
<script>
import { getBackGround } from "../../utils/wapAuth";

export default {
  name: "alert",
  props: {
    text: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: require("@/assets/img/v3/icon/_successful.svg")
    },
    type: {
      type: String,
      default: "alert-success"
    }
  },

  data() {
    return {
      bg: getBackGround()
    };
  },
  methods: {},
  mounted() {},
  watch: {}
};
</script>
<style scoped lang="scss">
.alert-container {
  padding: 15px;
  border-radius: v-bind("bg.b_radius2");
  .text-alert {
    text-align: left;
    font-weight: 400;
    font-size: 12.21px;
    line-height: 20px;
    letter-spacing: 0%;
    color: var(--Foreground-Ink-Beta, rgba(102, 102, 102, 1));
  }
}
.alert-success {
  background: radial-gradient(100% 476.39% at 0% 0%, #e6f4e7 0%, #ffffff 50%);
  border: 1px solid var(--Border-Success-Medium, rgba(176, 220, 181, 1));
}
.alert-info {
  background: radial-gradient(100% 476.39% at 0% 0%, #ebf5f5 0%, #ffffff 50%);
  border: 1px solid var(--Border-Primary-Medium, rgba(84, 130, 124, 1));
}
.alert-warning {
  background: radial-gradient(100% 476.39% at 0% 0%, #fdefe6 0%, #ffffff 50%);
  border: 1px solid var(--Border-Warning-Medium, rgba(248, 206, 176, 1));
}
.alert-danger {
  background: radial-gradient(100% 476.39% at 0% 0%, #fbe6e6 0%, #ffffff 50%);
  border: 1px solid var(--Border-Error-Medium, rgba(243, 176, 176, 1));
}
.alert-none {
  background: radial-gradient(100% 476.39% at 0% 0%, #ebf5f5 0%, #ffffff 50%);
  border: 1px solid var(--Border-Primary-Medium, rgba(84, 130, 124, 1));
}
</style>
